// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {ActivityState, ConnectivityState, Media, MediaType, PlayerMapping} from "@models";
import {SimDebriefingService, SimUtilityService} from "@services";

@Component({
	selector: "sim-media-card-audio",
	templateUrl: "./media-card-audio.component.html",
	styleUrls: ["./media-card-audio.component.scss"],
	standalone: false,
})
export class MediaCardAudioComponent {
	MediaType = MediaType;
	ConnectivityState = ConnectivityState;
	ActivityState = ActivityState;
	progressFromDisplayedMedia = SimUtilityService.progressFromDisplayedMedia;

	@Input() media: Media;
	@Input() mediaPlayer: PlayerMapping;
	@Input() listView: boolean = true;
	toggleMedia = output<{
		player: PlayerMapping;
		media: Media;
	}>();

	constructor(private _simStationDebriefingProxyService: SimDebriefingService) {}

	mediaClicked() {
		if (this.mediaPlayer?.webSocket?.activityState !== ActivityState.Inactive) {
			this.toggleMedia.emit({
				player: this.mediaPlayer,
				media: this.media,
			});
		}
	}
}
